export class Language {

    private countryCode: string;
    private id: number;
    private code: string;
    private name: string;
    private translationAvailable: boolean;
    private countryLanguageId: number;
    private countryLanguageCode: string;
    private countryLanguageTranslationAvailable: boolean;
    private order: number;

    constructor(raw: any) {
        if (raw) {
            this.setCountryCode(raw.COUNTRY_CODE);
            this.setId(raw.ID_LANGUAGE);
            this.setCode(raw.CODE?.replace('_', '-'));
            this.setName(raw.LANGUAGE_NAME);
            this.setTranslationAvailable(raw.LANGUAGE_TRANSLATION_FLAG === 'Y');
            this.setCountryLanguageId(raw.ID_COUNTRY_LANGUAGE);
            this.setCountryLanguageCode(raw.LANGUAGE_CODE);
            this.setCountryLanguageTranslationAvailable(raw.COUNTRY_LANGUAGE_TRANSLATION_FLAG === 'Y');
            this.setOrder(raw.ORDER_NUMBER);
        }
    }

    public getCountryCode(): string {
        return this.countryCode;
    }

    public setCountryCode(countryCode: string): void {
        this.countryCode = countryCode;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getCode(): string {
        return this.code;
    }

    public setCode(code: string): void {
        this.code = code;
    }

    public getName(): string {
        return this.name;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public isTranslationAvailable(): boolean {
        return this.translationAvailable;
    }

    public setTranslationAvailable(available: boolean): void {
        this.translationAvailable = available;
    }

    public getCountryLanguageId(): number {
        return this.countryLanguageId;
    }

    public setCountryLanguageId(countryLanguageId: number): void {
        this.countryLanguageId = countryLanguageId;
    }

    public getCountryLanguageCode(): string {
        return this.countryLanguageCode;
    }

    public setCountryLanguageCode(countryLanguageCode: string): void {
        this.countryLanguageCode = countryLanguageCode;
    }

    public isCountryLanguageTranslationAvailable(): boolean {
        return this.countryLanguageTranslationAvailable;
    }

    public setCountryLanguageTranslationAvailable(available: boolean): void {
        this.countryLanguageTranslationAvailable = available;
    }

    public getOrder(): number {
        return this.order;
    }

    public setOrder(order: number): void {
        this.order = order;
    }

}